module.exports = "/_next/static/images/f6c832bf3359f1f3ff7b65db4232c4cb-cards-left-small.jpg";